import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"404"}},[_c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c(VLayout,{attrs:{"align-center":"","justify-center":"","row":""}},[_c('div',{staticClass:"mr-3 hidden-sm-and-down"},[_c('img',{attrs:{"src":"/static/error/500.svg","alt":""}})]),_c('div',{staticClass:"text-md-center"},[_c('h1',[_vm._v("500")]),_c('h2',{staticClass:"my-3 headline"},[_vm._v("Sorry, the server is down.")]),_c('div',[_c(VBtn,{attrs:{"color":"primary"},on:{"click":_vm.goHome}},[_vm._v("Go Home")])],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }